import { adminHeaders, logoutAdmin } from "./auth";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

async function request(path, { method = "GET", body, signal } = {}) {
  const response = await fetch(`${API_URL}/garages${path}`, {
    method,
    signal,
    headers: {
      ...adminHeaders(),
      ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  });

  if (response.status === 401) logoutAdmin();
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || `Request failed: ${response.statusText}`);
  }
  if (response.status === 204) return null;
  return response.json();
}

export const fetchGarages = (signal) => request("/", { signal });
export const createGarage = (data) => request("/", { method: "POST", body: data });
export const updateGarage = (id, data) => request(`/${id}`, { method: "PUT", body: data });
export const resetGaragePassword = (id, password) =>
  request(`/${id}/reset-password`, { method: "POST", body: { password } });
export const deleteGarage = (id) => request(`/${id}`, { method: "DELETE" });
